import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import { GameType, gameTypeUnreliableCommentMap } from '@domain/constant/acca/test/result/gameType';
import classNames from 'classnames/bind';
import styles from './gameWarning.module.scss';

const cx = classNames.bind(styles);

interface GameWarningProps {
  gameTab: GameType;
}

const GameWarning = ({ gameTab }: GameWarningProps) => {
  const { accaResultStore } = useResultStore();
  const { accGameResult } = accaResultStore;

  if (!accGameResult) return null;

  const { details } = accGameResult;

  const isError = details?.find((detail) => {
    const { unreliableYn, type } = detail;
    if (type === gameTab) return unreliableYn;
  });

  if (!isError) return null;

  return <div className={cx('warningWrap')}>{gameTypeUnreliableCommentMap[gameTab]}</div>;
};

export default GameWarning;
